export const messagingMetricsTableColumns = (translate) => [
  {
    prop: 'actor_fullname',
    title: translate('common.fields.name'),
    width: '34%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_avg',
    title: translate('dashboard.messaging_metrics.average_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_median',
    title: translate('dashboard.messaging_metrics.median_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_pct20',
    title: translate('dashboard.messaging_metrics.20_percentile_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
];

export const documentMetricsTableColumns = (translate) => [
  {
    prop: 'actor_fullname',
    title: translate('common.fields.name'),
    width: '34%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_avg',
    title: translate('dashboard.messaging_metrics.average_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_median',
    title: translate('dashboard.messaging_metrics.median_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'response_time_pct20',
    title: translate('dashboard.messaging_metrics.20_percentile_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
];

export const permitIssueMetricsTableColumns = (translate) => [
  {
    prop: 'actor_fullname',
    title: translate('common.fields.name'),
    width: '34%',
    sortingEnabled: true,
  },
  {
    prop: 'delta_avg',
    title: translate('dashboard.messaging_metrics.average_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'delta_median',
    title: translate('dashboard.messaging_metrics.median_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
  {
    prop: 'delta_pct20',
    title: translate('dashboard.messaging_metrics.20_percentile_response_time'),
    width: '22%',
    sortingEnabled: true,
  },
];

export const permitStatusMetricsTableColumns = (translate) => [
  {
    prop: 'actor_fullname',
    title: translate('common.fields.name'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'filled',
    title: translate('dashboard.permit_metrics.filled'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'skipped',
    title: translate('dashboard.permit_metrics.skipped'),
    width: '25%',
    sortingEnabled: true,
  },
  {
    prop: 'completion_rate',
    title: translate('dashboard.permit_metrics.completion_rate'),
    width: '25%',
    sortingEnabled: true,
  },
];

export const permitActionDatesMetricsTableColumns = (translate) => [
  {
    prop: 'actor_fullname',
    title: translate('common.fields.name'),
    width: '18.5%',
    sortingEnabled: true,
  },
  {
    prop: 'total',
    title: translate('dashboard.permit_metrics.total'),
    width: '13.5%',
    sortingEnabled: true,
  },
  {
    prop: 'filled',
    title: translate('dashboard.permit_metrics.filled'),
    width: '15%',
    sortingEnabled: true,
  },
  {
    prop: 'skipped',
    title: translate('dashboard.permit_metrics.skipped'),
    width: '15%',
    sortingEnabled: true,
  },
  {
    prop: 'filled_shared',
    title: translate('dashboard.permit_action_date_metrics.filled_shared'),
    width: '17.5%',
    sortingEnabled: true,
  },
  {
    prop: 'completion_rate',
    title: translate('dashboard.permit_metrics.completion_rate'),
    width: '15%',
    sortingEnabled: true,
  },
];
